<div class="row no-gutters">
  <div class="col-12 col-lg-2 col-xl-3"></div>
  <div class="col-12 col-lg-8 col-xl-6">
    <div class="col-12 mx-auto text-center confirmation-tick-container">
      <img src="assets/icons/svg/checkout-confirmation-tick.svg"
            class="confirmation-tick-img"
            title="Po Upload Confirmed"
            alt="Po Upload Confirmed"
            aria-label="Po Upload Confirmed"/>
    </div>

    <div class="col-12 text-center upper-message">{{ 'poUploadCart.confirmationTitle' | cxTranslate }}</div>
    <div class="row no-gutters lower-message-margin">
      <div class="col-12 col-lg-7 mx-auto text-center">
        <span class="lower-message">{{ 'poUploadCart.confirmationDetails' | cxTranslate }}</span>
      </div>
    </div>

    <div class="col-12">
      <button class="btn btn-block btn-primary mb-confirmation-btn text-initial mx-auto"
              type="button"
              (click)="navigateToHomePage()">
        <strong>{{ 'mbcommon.continueShopping' | cxTranslate }}</strong>
      </button>
    </div>
    </div>
  <div class="col-12 col-lg-2 col-xl-3"></div>
</div>
